var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ad20eb2b-97a8-4612-b153-4cf1d84a5eed",
    "data-name": "C-wires layered OFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 593.17 196.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".C-wire-channel,.a31155b2-cff0-4493-9c37-c2343d1bdb80{fill:none;}.C-wire-channel{stroke:#d2e4f9;stroke-linecap:round;stroke-linejoin:round;stroke-width:9px;}.a31155b2-cff0-4493-9c37-c2343d1bdb80{stroke:#b290d1;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a390d492-f831-4dae-88a2-3136aff28926",
    "data-name": "Channel"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M15.45,28.67l131.44,76.17a4,4,0,0,0,4,0l20.53-11.7a4,4,0,0,1,4,0l148,86.82a4,4,0,0,0,2,.55h50.84a4,4,0,0,0,2-.54L532.19,91a4,4,0,0,0,2-3.47V42.86a4,4,0,0,1,2-3.47L577.71,15.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b617182d-445b-41eb-856f-bc8f0dd6357e",
    "data-name": "OFF"
  }, /*#__PURE__*/React.createElement("path", {
    className: "C-wire-channel",
    d: "M15.45,28.67l131.44,76.17a4,4,0,0,0,4,0l20.53-11.7a4,4,0,0,1,4,0l148,86.82a4,4,0,0,0,2,.55h50.84a4,4,0,0,0,2-.54L532.19,91a4,4,0,0,0,2-3.47V42.86a4,4,0,0,1,2-3.47L577.71,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a31155b2-cff0-4493-9c37-c2343d1bdb80",
    d: "M15.45,28.67l131.44,76.17a4,4,0,0,0,4,0l20.53-11.7a4,4,0,0,1,4,0l148,86.82a4,4,0,0,0,2,.55h50.84a4,4,0,0,0,2-.54L532.19,91a4,4,0,0,0,2-3.47V42.86a4,4,0,0,1,2-3.47L577.71,15.6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.2d53376b.svg";
export { ForwardRef as ReactComponent };